import { createContext }	from "preact";
import { useContext }		from "preact/hooks";

import * as commonModel	from "@geotoura/shared/commonModel";
import * as upModel		from "@geotoura/shared/upModel";

import { Table }	from "@geotoura/up/table";

export type UpData	= Readonly<{
	markers:			ReadonlyArray<upModel.Marker>,
	isoCountries:		ReadonlyArray<commonModel.IsoCountry>,
	airports:			ReadonlyArray<commonModel.DestinationId>,

	rawExampleRoutes:	ReadonlyArray<upModel.ExampleRouteSummary>,
	rawRegions:			ReadonlyArray<upModel.Region>,
	rawTerritories:		ReadonlyArray<upModel.Territory>,
	// rawHotelSites:		ReadonlyArray<commonModel.HotelSite>,
	rawHotelCategories:	ReadonlyArray<commonModel.HotelCategory>,
	rawCarCategories:	ReadonlyArray<commonModel.CarCategory>,

	territory:			Table<commonModel.TerritoryId,		upModel.Territory>,
	region:				Table<commonModel.RegionId,			upModel.Region>,
	destination:		Table<commonModel.DestinationId,	upModel.Marker>,
	route:				Table<commonModel.ExampleRouteId,	upModel.ExampleRouteSummary>,
	hotelCategory:		Table<commonModel.HotelCategoryId,	commonModel.HotelCategory>,
	hotelSite:			Table<commonModel.HotelSiteId,		commonModel.HotelSite>,
	carCategory:		Table<commonModel.CarCategoryId,	commonModel.CarCategory>,
}>;

export const buildUpData	= (rawUpData:upModel.RawUpData):UpData	=> ({
	markers:			rawUpData.markers,
	isoCountries:		rawUpData.isoCountries,
	airports:			rawUpData.airports,

	rawExampleRoutes:	rawUpData.exampleRoutes,
	rawRegions:			rawUpData.regions,
	rawTerritories:		rawUpData.territories,
	// rawHotelSites:		rawUpData.hotelSites,
	rawHotelCategories:	rawUpData.hotelCategories,
	rawCarCategories:	rawUpData.carCategories,

	territory:			Table.build("territory",		rawUpData.territories,		"id"),
	region:				Table.build("region",			rawUpData.regions,			"id"),
	destination:		Table.build("destination",		rawUpData.markers,			"id"),
	route:				Table.build("route",			rawUpData.exampleRoutes,	"id"),
	hotelCategory:		Table.build("hotelCategory",	rawUpData.hotelCategories,	"id"),
	hotelSite:			Table.build("hotelSite",		rawUpData.hotelSites,		"id"),
	carCategory:		Table.build("carCategory",		rawUpData.carCategories,	"id"),
} as const);

const fakeUpData:UpData	= {
	markers:			[],
	isoCountries:		[],
	airports:			[],
	rawExampleRoutes:	[],
	rawRegions:			[],
	rawTerritories:		[],
	// rawHotelSites:		[],
	rawHotelCategories:	[],
	rawCarCategories:	[],
	region:				Table.empty("region"),
	territory:			Table.empty("territory"),
	destination:		Table.empty("destination"),
	route:				Table.empty("route"),
	hotelCategory:		Table.empty("hotelCategory"),
	hotelSite:			Table.empty("hotelSite"),
	carCategory:		Table.empty("carCategory"),
} as const;

const Context	= createContext<UpData>(fakeUpData);

export const UpDataProvider	= Context.Provider;

export const useUpData	= ():UpData => useContext(Context);
